<template>
  <div id="video-sidenav">
    <Input
      class="w-auto mb-2"
      :label="$t('new-url')"
      :value="options.url"
      @enter="updateUrl($event)"
      @blur="updateUrl($event)"
    />
    <strong>{{ $t('size') }}</strong>
    <Toggle :label="$t('fit-to-panel')" :value="!options.staticVideo" @toggle="checkStaticVideo(!$event)" />

    <div class="d-flex justify-content-between mb-3 mt-3">
      <div class="placement">
        <span class="text-capitalize">{{ $t('width') }} (px)</span>
        <PlacementNumber
          :initial="videoWidth"
          @change="changeValues('width', $event)"
          :negative="false"
          :increment="25"
          :disabled="!options.staticVideo"
        />
      </div>
      <div class="placement">
        <span class="text-capitalize">{{ $t('height') }} (px)</span>
        <PlacementNumber
          :initial="videoHeight"
          @change="changeValues('height', $event)"
          :negative="false"
          :disabled="!options.staticVideo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WidgetSideNavMixin from '@/components/sidenav/landing/panel/widget/Mixin.js'

export default {
  name: 'VideoSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.panel.widget.video-side-nav' },
  mixins: [WidgetSideNavMixin],
  data() {
    return {
      videoWidth: 0,
      videoHeight: 0,
      aspectRatio: 0,
    }
  },
  methods: {
    updateUrl(url) {
      this.propChanged('', {
        ...this.widget.options,
        url,
        staticVideo: false,
      })
    },
    changeValues(type, value) {
      if (type === 'width') {
        this.videoWidth = value
        this.videoHeight = Math.ceil(value / this.aspectRatio)
      } else {
        this.videoWidth = Math.ceil(value * this.aspectRatio)
        this.videoHeight = value
      }
      this.propChanged('', {
        ...this.widget.options,
        width: this.videoWidth,
        height: this.videoHeight,
      })
    },
    initValues() {
      this.videoWidth =
        this.widget.options.staticVideo && this.widget.options.width
          ? this.widget.options.width
          : document.getElementById(this.widget.id).clientWidth
      this.videoHeight =
        this.widget.options.staticVideo && this.widget.options.height
          ? this.widget.options.height
          : document.getElementById(this.widget.id).clientHeight
      this.aspectRatio = this.videoWidth / this.videoHeight
    },
    checkStaticVideo(staticVideo) {
      if (
        staticVideo &&
        (this.videoWidth !== this.widget.options.width || this.videoHeight !== this.widget.options.height)
      ) {
        this.propChanged('', {
          ...this.widget.options,
          width: this.videoWidth,
          height: this.videoHeight,
          staticVideo,
        })
      } else {
        this.propChanged('staticVideo', staticVideo)
      }
    },
  },
  created() {
    this.initValues()
    this.widget.onVideoLoaded = () => {
      this.videoWidth = this.widget.options.width
      this.videoHeight = this.widget.options.height
      this.aspectRatio = this.videoWidth / this.videoHeight
    }
  },
}
</script>

<style lang="scss" scoped>
.placement {
  width: 135px;
}
</style>
